export class SendMessagePayloadDto {
  message: {
    text: string
  };
  sender: {
    source_id: number,
    type: string
  };
  sender_id: string;
  time: number;
  constructor() {
    this.message = {text: ''};
    this.sender = {source_id: 0, type: 'page'};
  }
}
